import { HOST, } from "common/constants";
import { Box, Typography } from "@mui/material";
// Hooks
import { useTranslation } from "react-i18next";

import classes from "./infoHistory.module.scss";
import { useEffect, useState } from "react";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import axios from "axios";
import parse from "html-react-parser";

const InfoHistory = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
      const currentLang = i18n.language;

  const [education, setEducation] = useState(null);

  useEffect(() => {
    const fetchEducation = async () => {
      try {
        const res = await axios.get(`${HOST}/api/v1/history/`);
        setEducation(res.data.results?.[0]);
      } catch (err) {
        console.error("Ошибка при получении данных об образовании:", err);
      }
    };

    fetchEducation();
  }, []);

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {});
    return () => Fancybox.destroy();
  }, []);

  const descriptionKey = `description_${currentLang}`;
    const parsedDescription = parse(education?.[descriptionKey] || "", {
    replace: (domNode) => {
      if (
        domNode.name === "img" &&
        domNode.attribs?.src &&
        domNode.attribs.src.startsWith("/")
      ) {
        domNode.attribs.src = HOST + domNode.attribs.src;
        delete domNode.attribs.style;

        return (
          <a data-fancybox="gallery" href={domNode.attribs.src}>
            <img
              src={domNode.attribs.src}
              alt="img"
              style={{
                maxWidth: "100%",
                width: "100%",
                height: "auto",
                display: "block",
                position: "static",
              }}
            />
          </a>
        );
      }

      if (domNode.name === "oembed" && domNode.attribs?.url) {
        return (
          <Box my={4}>
            <iframe
              width="100%"
              height="424"
              src={domNode.attribs.url}
              title="video"
              allowFullScreen
              style={{ borderRadius: "8px", border: "none" }}
            ></iframe>
          </Box>
        );
      }

      if (domNode.name === "a" && domNode.attribs?.href) {
        // Если начинается с "/", добавить HOST
        if (domNode.attribs.href.startsWith("/")) {
          domNode.attribs.href = HOST + domNode.attribs.href;
        }
  
        // Открывать в новой вкладке все внешние ссылки
        if (
          domNode.attribs.href.startsWith("http") ||
          domNode.attribs.href.startsWith("https")
        ) {
          domNode.attribs.target = "_blank";
          domNode.attribs.rel = "noopener noreferrer";
        }
      }

      return undefined;
    },
  });



  return (
    <Box className={classes.textWrapper}>
      <Typography className={classes.title}>{t("historyAboutUs")}</Typography>
      {education && (
        <Box className={classes.textContent}>
           <a data-fancybox="gallery" href={education.image}>
            <img src={education.image} alt="img" />
          </a>
          <Box className={classes.description}>{parsedDescription}</Box>
        </Box>
      )}
    </Box>
  );
};

export default InfoHistory;
